export default {
    buttons: {
        back: '이전 페이지',
        home: '홈으로 이동',
    },
};
